import Proof1 from '@assets/proof/Results-1.jpg';
import Proof10 from '@assets/proof/Results-10.jpg';
import Proof11 from '@assets/proof/Results-11.jpg';
import Proof2 from '@assets/proof/Results-2.jpg';
import Proof3 from '@assets/proof/Results-3.jpg';
import Proof4 from '@assets/proof/Results-4.jpg';
import Proof5 from '@assets/proof/Results-5.jpg';
import Proof6 from '@assets/proof/Results-6.jpg';
import Proof7 from '@assets/proof/Results-7.jpg';
import Proof8 from '@assets/proof/Results-8.jpg';
import Proof9 from '@assets/proof/Results-9.jpg';
import React from 'react';
import styled from 'styled-components';
import { BottomNotch } from '../../../components/GlobalStyles';

export const SectionProof = function() {
  return (
    <Container>
      <Grid>
        <GridItem>
          <Proof src={Proof1} />
        </GridItem>
        <GridItem>
          <Proof src={Proof2} />
        </GridItem>
        <GridItem>
          <Proof src={Proof3} />
        </GridItem>
        <GridItem>
          <Proof src={Proof4} />
        </GridItem>
        <GridItem>
          <Proof src={Proof5} />
        </GridItem>
        <GridItem>
          <Proof src={Proof6} />
        </GridItem>
        <GridItem>
          <Proof src={Proof7} />
        </GridItem>
        <GridItem>
          <Proof src={Proof8} />
        </GridItem>
        <GridItem>
          <Proof src={Proof9} />
        </GridItem>
        <GridItem>
          <Proof src={Proof10} />
        </GridItem>
        <GridItem>
          <Proof src={Proof11} />
        </GridItem>
      </Grid>
      <BottomNotch color="var(--colorPrimaryLight)" />
    </Container>
  );
};

const Container = styled.section`
  margin: 0;

  position: relative;
  width: 100vw;
  background-color: var(--colorPrimaryLight);

  padding: 0 5.5rem;
`;

const Grid = styled.div`
  position: relative;
  z-index: 2;

  transform: translateY(-5.2rem);

  max-width: 140rem;
  margin-left: auto;
  margin-right: auto;

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(auto, 38rem));
  gap: 3.2rem;
  justify-content: center;
  justify-items: stretch;
`;

const GridItem = styled.div`
  /* padding: 1.2rem; */
  /* max-width: 38rem; */
`;

const Proof = styled.img`
  border-radius: 1.6rem;
  border: rgba(0, 0, 0, 0.15) solid 0.1rem;
  box-shadow: 0 0.2rem 0.6rem 0 rgba(0, 0, 0, 0.15);
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionProof.js